module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner-center"
  }, [_c('div', {
    staticClass: "container stable-quicken"
  }, [_c('div', {
    staticClass: "content content-bottom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vertical-middle text-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('visitglobal')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('visitcontent1')))]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.getNow()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('getNow')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container safe"
  }, [_c('div', {
    staticClass: "content content-bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "vertical-middle text-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('privacyprotection')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('privacycontent1')))]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.getNow()
      }
    }
  }, [_vm._v("\n\n          " + _vm._s(_vm.$t('getNow')) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container special"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "special-lists"
  }, [_c('li', [_c('div', {
    staticClass: "spe-line"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/newhome_img/spe1-m.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "special-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('advantage1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('advantagecontent1')))])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "spe-line"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/newhome_img/spe2-m.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "special-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('advantage2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('advantagecontent2')))])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "spe-line"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/newhome_img/spe3-m.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "special-right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('advantage3')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('advantagecontent3')))])]), _vm._v(" "), _c('hr')])])])]), _vm._v(" "), _c('div', {
    staticClass: "container stable-quicken global"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "vertical-middle"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('globalNote')))]), _vm._v(" "), _c('p', {
    staticClass: "text-content3"
  }, [_vm._v(_vm._s(_vm.$t('advantagecontent')))]), _vm._v(" "), _c('div', {
    staticClass: "get-now",
    on: {
      "click": function($event) {
        return _vm.getNow()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('getNow')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container stable-quicken"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "vertical-middle"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('multipleDevices')))]), _vm._v(" "), _c('p', {
    staticClass: "text-content3"
  }, [_vm._v(_vm._s(_vm.$t('multipleDevicesContent')))]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.getNow()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('getNow')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container evaluate"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('evaluate')))]), _vm._v(" "), _c('div', {
    staticClass: "evaluate-box"
  }, [_c('img', {
    staticClass: "left-btn",
    attrs: {
      "src": "/static/img/newhome_img/leftarrow.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "evaluate-list"
  }, [_c('ul', {
    staticClass: "evaluate-lists"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[0] : _vm.imgdata.en[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate1')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[1] : _vm.imgdata.en[1],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate2')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[2] : _vm.imgdata.en[2],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName3')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate3')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[3] : _vm.imgdata.en[3],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName4')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate4')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[4] : _vm.imgdata.en[4],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName5')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate5')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[5] : _vm.imgdata.en[5],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName6')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate6')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": _vm.lan == 'zh' ? _vm.imgdata.zh[6] : _vm.imgdata.en[6],
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('userName7')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('userEvaluate7')))])])])]), _vm._v(" "), _c('img', {
    staticClass: "right-btn",
    attrs: {
      "src": "/static/img/newhome_img/rightarrow.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "container compatibility"
  }, [_c('div', {
    staticClass: "content text-center"
  }, [_c('p', [_c('router-link', {
    staticClass: "download-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('download')))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=windows",
      "aria-label": "windows"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-windows"
    }
  })])])]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=mac",
      "aria-label": "mac"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-Macos"
    }
  })])])]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=ios",
      "aria-label": "ios"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-pingguo"
    }
  })])])]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=android",
      "aria-label": "android"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-anzhuo"
    }
  })])])]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=ubuntu",
      "aria-label": "ubuntu"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-Ubuntu"
    }
  })])])]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=androidTV",
      "aria-label": "android_tv"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-androidTV"
    }
  })])])])], 1)])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-middle text-left"
  }, [_c('img', {
    staticClass: "circle-img",
    attrs: {
      "src": "/static/img/newhome_img/content1copy.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-middle text-left"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newhome_img/content2copy.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-middle text-left"
  }, [_c('img', {
    staticClass: "computer-img",
    attrs: {
      "src": "/static/img/newhome_img/newcontent4.jpg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-middle text-left"
  }, [_c('img', {
    staticClass: "computer-img",
    attrs: {
      "src": "/static/img/newhome_img/content3.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bfad79e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/homeBodyPhone/HomeBodyPhone.vue
// module id = 1328
// module chunks = 1